import { defineComponent } from "vue";

import EmergencyPreparednessSection from "./EmergencyPreparednessSection/EmergencyPreparednessSection.vue";
import EvacuationSection from "./EvacuationSection/EvacuationSection.vue";

export default defineComponent({
    components: {
        EmergencyPreparednessSection,
        EvacuationSection
    }
});
